import { Icon } from 'gu-ui-kit'
import React from 'react'

export default () => {
  return {
    initial: {
      query: '',
      advertising_type_ids: [],
    },
    configuration: {
      advertising_type_ids: {
        subbutton: {
          isVisible: (value = [], breakpoints) =>
            value.length > 0 || !!breakpoints.fb,
        },
        icon: (
          <Icon
            name={'checkmark2'}
            size={'s'}
            bgColor={'secondary-11'}
            color={'basic-primary-white'}
          />
        ),
        label:
          'services::networks_list.filters.dropdown.items.advertising_type.label',
        position: 'dropdown',
        type: 'checkbox group',
        optionLabelPrefix: '',
        options: [],
      },
      query: {
        subbutton: { isVisible: (value = '') => !!value },
        label: 'services::networks_list.filters.input.label',
        placeholder: 'services::networks_list.filters.input.label',
        order: 1,
        type: 'input',
      },
    },
  }
}
